(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["personalise"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-personalise-file-wrapper]').forEach((wrapper) => {
    const input = wrapper.querySelector('[data-personalise-file-input]');
    const nameEl = wrapper.querySelector('[data-personalise-file-name]');
    if (!input || !nameEl) return;
    const defaultText = nameEl.textContent;
    input.addEventListener('change', () => {
      nameEl.textContent = input.files && input.files.length > 0 ? input.files[0].name : defaultText;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
